import { PATHS } from '@/constants/path';

export const isPendingDirectIdpResolve = () => {
  try {
    return globalThis.sessionStorage?.getItem('pending_idp_resolve') === 'direct';
  } catch {
    return false;
  }
};

// window.location.assign に渡す前に、同一オリジンの相対パスのみを許可する。
// sessionStorage が改ざんされても外部サイトへ遷移(オープンリダイレクト)しないよう、
// 先頭が単一の '/' で始まるパスだけを通す（'//host' や '/\host' は protocol-relative
// として外部オリジン扱いになるため弾く）。
const sanitizeCallbackUrl = (url: string | null | undefined): string => {
  if (!url || url[0] !== '/' || url[1] === '/' || url[1] === '\\') return PATHS.ROOT;
  return url;
};

// IdP 直接パスでログインを実行したページ URL を取り出して破棄する。
// next-auth の redirect 先に依存せず、認証完了後に確実に元ページへ戻すために使う。
export const consumeIdpCallbackUrl = (): string => {
  try {
    const url = globalThis.sessionStorage?.getItem('idp_resolve_callback_url');
    globalThis.sessionStorage?.removeItem('idp_resolve_callback_url');
    return sanitizeCallbackUrl(url);
  } catch {
    return PATHS.ROOT;
  }
};
